import React, { useEffect, useState } from 'react';

const MIPERFIL_ARCHIVO =
  'https://institutobilinguelasnaciones.com/terapias/backend/especialistasNuevos.php';

const campoLargo = (campo) => (campo.valor || '').length > 90;

const paramsDeUrl = (url) => {
  const query = String(url || '').split('?')[1] || '';
  const params = {};

  query.split('&').forEach((part) => {
    const indice = part.indexOf('=');

    if (indice === -1) {
      return;
    }

    params[decodeURIComponent(part.slice(0, indice))] = decodeURIComponent(part.slice(indice + 1) || '');
  });

  return params;
};

const hrefArchivo = (campo, planillaId) => {
  const params = paramsDeUrl(campo && campo.url);
  const id = Number(params.id) || Number(planillaId) || 0;
  const tipo = params.tipo || campo.tipo_archivo || '';

  if (id > 0 && tipo) {
    return MIPERFIL_ARCHIVO + '?boton=archivo&id=' + id + '&tipo=' + encodeURIComponent(tipo);
  }

  return '';
};

const AdminSpecialistPlanilla = ({ planilla, cargando, error, onBack, onSave, guardando, aviso }) => {
  const [local, setLocal] = useState(planilla);
  const [activa, setActiva] = useState('datos');

  useEffect(() => {
    setLocal(planilla);
    const siguientes = (planilla && planilla.secciones) || [];

    if (siguientes.length > 0) {
      setActiva(siguientes[0].id);
    }
  }, [planilla]);

  const secciones = (local && local.secciones) || [];
  const seccion = secciones.find((item) => item.id === activa) || secciones[0];
  const mostrarFoto = seccion && seccion.id === 'datos' && local && local.foto;

  const actualizarCampo = (seccionId, indiceCampo, valor, enFila, indiceFila) => {
    setLocal((actual) => {
      if (!actual) {
        return actual;
      }

      return {
        ...actual,
        secciones: actual.secciones.map((item) => {
          if (item.id !== seccionId) {
            return item;
          }

          if (enFila) {
            return {
              ...item,
              filas: item.filas.map((fila, filaIndex) =>
                filaIndex === indiceFila
                  ? fila.map((campo, campoIndex) =>
                      campoIndex === indiceCampo ? { ...campo, valor } : campo
                    )
                  : fila
              ),
            };
          }

          return {
            ...item,
            campos: item.campos.map((campo, campoIndex) =>
              campoIndex === indiceCampo ? { ...campo, valor } : campo
            ),
          };
        }),
      };
    });
  };

  const dibujarCampo = (campo, indiceCampo, enFila, indiceFila) => {
    const clase = 'admin-planilla-field' + (campoLargo(campo) ? ' admin-planilla-field--wide' : '');
    const clave = (enFila ? 'fila-' + indiceFila + '-' : '') + (campo.clave || campo.etiqueta) + '-' + indiceCampo;

    if (campo.url) {
      return (
        <div key={clave} className={clase}>
          <span>{campo.etiqueta}</span>
          <a
            className="admin-planilla-file-link"
            href={hrefArchivo(campo, local && local.id)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {campo.valor || 'Abrir archivo'}
          </a>
        </div>
      );
    }

    return (
      <label key={clave} className={clase}>
        <span>{campo.etiqueta}</span>
        {campo.clave ? (
          campoLargo(campo) ? (
            <textarea
              className="profile-ficha-input"
              rows={4}
              value={campo.valor || ''}
              onChange={(event) => actualizarCampo(seccion.id, indiceCampo, event.target.value, enFila, indiceFila)}
            />
          ) : (
            <input
              className="profile-ficha-input"
              type="text"
              value={campo.valor || ''}
              onChange={(event) => actualizarCampo(seccion.id, indiceCampo, event.target.value, enFila, indiceFila)}
            />
          )
        ) : (
          <p>{campo.valor || '—'}</p>
        )}
      </label>
    );
  };

  return (
    <div className="admin-planilla">
      <div className="admin-planilla-top">
        <button type="button" className="admin-btn admin-btn--secondary" onClick={onBack}>
          Volver a la lista
        </button>
      </div>
      {local ? (
        <div className="admin-planilla-heading">
          <h3>{local.nombre}</h3>
          <p className="admin-muted">
            Puedes corregir los datos de Mi Perfil. La edad se calcula sola.
          </p>
        </div>
      ) : null}
      {error ? (
        <div className="admin-alert admin-alert--error" role="alert">
          {error}
        </div>
      ) : null}
      {aviso ? (
        <div className="admin-alert admin-alert--success" role="status">
          {aviso}
        </div>
      ) : null}
      {cargando ? <p className="admin-muted">Cargando planilla…</p> : null}
      {!cargando && local && seccion ? (
        <>
          <div className="admin-planilla-tabs" role="tablist">
            {secciones.map((item, index) => (
              <button
                key={item.id}
                type="button"
                role="tab"
                aria-selected={seccion.id === item.id}
                className={'admin-planilla-tab' + (seccion.id === item.id ? ' admin-planilla-tab--active' : '')}
                onClick={() => setActiva(item.id)}
              >
                {index + 1}. {item.titulo}
              </button>
            ))}
          </div>
          <div className="admin-planilla-body" role="tabpanel">
            {mostrarFoto ? (
              <img className="admin-planilla-photo" src={local.foto} alt={'Foto de ' + local.nombre} />
            ) : null}
            {seccion.campos.length > 0 ? (
              <div className="admin-planilla-grid">
                {seccion.campos.map((campo, indiceCampo) => dibujarCampo(campo, indiceCampo, false))}
              </div>
            ) : null}
            {seccion.filas.map((fila, indiceFila) => (
              <div key={seccion.id + '-' + indiceFila} className="admin-planilla-card">
                <div className="admin-planilla-grid">
                  {fila.map((campo, indiceCampo) => dibujarCampo(campo, indiceCampo, true, indiceFila))}
                </div>
              </div>
            ))}
            {seccion.campos.length === 0 && seccion.filas.length === 0 ? (
              <p className="admin-muted">Sin datos en esta sección.</p>
            ) : null}
          </div>
          <button
            type="button"
            className="admin-btn admin-btn--primary"
            disabled={guardando || !onSave}
            onClick={() => onSave(local)}
          >
            {guardando ? 'Guardando…' : 'Guardar planilla'}
          </button>
        </>
      ) : null}
    </div>
  );
};

export default AdminSpecialistPlanilla;
